<script>
  import { External } from '../../../../../external';

  export let data = { booking: { start: 0, eventData: { name: '' } } },
    contact;

  const start = data.booking?.start || 0;
  const name = data.booking?.eventData?.name || '';

</script>

<b>{External.Tools.dateToString(new Date(start * 1000), true)} - "{name}"</b>
